<template>
  <section data-aos="fade-right" data-aos-offset="350" class="aos-init aos-animate">
    <h2 class="title-medium section-title">I nostri video</h2>
    <div class="video-wrapper">
      <iframe :src="featuredVideo.youtube_uri" frameborder="0" allowfullscreen="" style="width: 445.5px; height: 250.594px;"></iframe>
      <p class="video-follow"><a href="https://www.youtube.com/user/EdizioniCaramba" rel="external nofollow noopener" target="_blank">Seguici sul nostro canale Youtube</a></p>
    </div>
  </section>
</template>

<script>
import axios from 'axios/dist/axios';

export default {
  //props: ['featuredVideo'],
  data() {
    return {
      featuredVideo: {}
    }
  },
  mounted() {
    axios.get(window.location.origin + '/api/v1/video/list')
      .then(resp => this.featuredVideo = resp.data[0]);
  }
}
</script>



// WEBPACK FOOTER //
// src/vue/components/FeaturedVideo.vue